import { FNOLResults } from "../../src/components";

export default function FNOLFormResults() {
  return (
    <div className="cure-inner-container">
      <FNOLResults />
    </div>
  )
}
